import React, { Component } from 'react';
import AccordionPrefix from './AccordionPrefix';
import __ from '../../utils/translator';
import Accordion from './Accordion';
import AccordionTitle from './AccordionTitle';
import AccordionItemContainer from './AccordionItemContainer';
import AccordionItem from './AccordionItem';
import ThemeStatus from '../ThemeStatus';
import Loading from './Loading';
import withUserReportData from '../../hoc/withUserReportData';
import ReportStore from '../../flux/reports/ReportStore';
import ReportStoreActions from '../../flux/reports/ReportStoreActions';
import collectionTypeToParentType from '../../utils/collectionTypeToParentType';
import mapObject from '../../utils/reports/mapObject';
import groupBy from 'lodash.groupby';
import { withRouter } from 'react-router-dom';
import generateReportUrl from '../../utils/reports/generateReportUrl';
import getRedirectProps from '../../utils/reports/getRedirectProps';
import sortAlphabetically from '../../utils/reports/sortAlphabetically';
import ReportLoadingError from './ReportLoadingError';
import CollectionTypes from '../../flux/reports/CollectionTypes';
import RenderOnTablet from "../responsive/RenderOnTablet";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import { ItemSmallLabel, TitleSmallLabel } from "./ReportsLabels";
import NoResults from "../NoResults";
import { withTheme } from "styled-components";
import RenderOnMobile from "../responsive/RenderOnMobile";

class PersonalReportViewContainer extends Component {
  state = {
    data: [],
    themesCompleted: this.props.themesCompleted,
    themesCount: this.props.themesCount,
    isLoading: this.props.isLoading,
    themes: this.props.themes,
  };

  subscriptions = [];

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.collectionType !== prevState.collectionType ||
      nextProps.parentId !== prevState.parentId ||
      nextProps.data !== prevState.data ||
      nextProps.isLoading  !== prevState.isLoading  ||
      nextProps.themes !== prevState.themes
    ) {
      return nextProps;
    }

    return null;
  }

  componentDidMount() {
    this.fetchReportData();

    this.subscriptions.push(ReportStore.addListener(() => {
      const { data, loading, error } = ReportStore.getState();

      this.setState({
        // @todo 2019-02-25
        //   We take only the first store, even if the user is associated to
        //   multiple store_departments. This means even if the user works in
        //   multiple stores only one (random) will be shown.
        data: data.slice(0, 1),
        isLoading: loading,
        error
      }, () => {
        const redirectProps = getRedirectProps(this.state.data);

        if (redirectProps === null) {
          return;
        }

        const path = generateReportUrl(this.state.match.params.collectionType, {
          ...this.state.match.params, ...redirectProps
        });

        this.state.history.replace(path);
      });
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.collectionType !== this.state.collectionType ||
      prevState.parentId !== this.state.parentId
    ) {
      this.fetchReportData();
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  fetchReportData = () => {
    ReportStoreActions.fetch(
      collectionTypeToParentType(this.props.collectionType),
      this.props.parentId
    );
  };

  render() {
    if (this.state.error !== null) {
      return (
        <ReportLoadingError />
      )
    }

    return (
      <React.Fragment>
        <RenderOnTablet>
          <AccordionPrefix columns={['50%', '20%', '30%']}>
            <span />
            <span>{__('Completed theme')}</span>
            <span />
          </AccordionPrefix>
        </RenderOnTablet>
        {mapObject(sortAlphabetically(groupBy(this.state.data, 'store_id'), value => (
          // @todo 2019-02-25 Copied from CountryStoreReport, consider a refactor
          this.state.data.find(row => row.store_id === value).store_name
        )), (storeData, store) => (
          <Accordion key={store}>
            <div style={{ boxShadow: themeResponsiveProperty('0px 0px 4px rgba(0, 0, 0, 0.25)', null)(this.props) }}>
              <AccordionTitle
                to={generateReportUrl(this.state.collectionType, { parentId: this.state.parentId, ...getRedirectProps(storeData) })}
                isExpanded={true}
                columns={themeResponsiveProperty(['60%', '30%', '10%'], ['50%', '20%', '30%'])(this.props)}
                style={{ borderBottom: themeResponsiveProperty('0', null)(this.props) }}
                replace
              >
                <TitleSmallLabel>
                  {storeData[0].store_name}
                </TitleSmallLabel>

                <RenderOnMobile>
                  <ItemSmallLabel>
                    {__('Completed Themes')}
                  </ItemSmallLabel>
                </RenderOnMobile>

                <TitleSmallLabel style={{ textAlign: themeResponsiveProperty('right', null)(this.props) }}>
                  {storeData[0].completed_themes}/{storeData[0].total_themes}
                </TitleSmallLabel>

                <RenderOnTablet>
                  <span />
                </RenderOnTablet>

              </AccordionTitle>
            </div>
            <AccordionItemContainer isVisible={this.state.match.params.store === store}>
              {this.state.themes.map(theme => (
                <AccordionItem
                  key={theme.id}
                  to="#"
                  columns={themeResponsiveProperty(['70%', '30%'], ['50%', '20%', '30%'])(this.props)}
                  style={{borderBottom: 0}}
                >
                  <ItemSmallLabel>
                    {theme.name}
                  </ItemSmallLabel>

                  <ItemSmallLabel style={{
                    display: themeResponsiveProperty('flex', null)(this.props),
                    justifyContent: themeResponsiveProperty('flex-end', null)(this.props),
                    color: theme.status === 'theme_completed' ? '#489a46' : null
                  }}>
                    <ThemeStatus status={theme.status} />
                  </ItemSmallLabel>

                  <RenderOnTablet>
                    <span />
                  </RenderOnTablet>

                </AccordionItem>
              ))}

              {this.state.isLoading === true && this.state.themes.length === 0 && (
                <AccordionItem to="#" style={{ justifyContent: 'center', }}>
                  <Loading />
                </AccordionItem>
              )}

              {this.state.isLoading === false && this.state.themes.length === 0 && (
                <NoResults message={__('No results for the selected collection')} />
              )}
            </AccordionItemContainer>
          </Accordion>
        ))}

        {this.state.isLoading === false && this.state.data.length === 0 && (
          <NoResults message={this.state.collectionType === CollectionTypes.COLLECTION_TYPE_SEASONAL ? (
            __('No results for the selected collection.')
          ) : (
            __('No results for the selected timeless.')
          )} />
        )}
      </React.Fragment>
    );
  }
}

export default withUserReportData(withTheme(withRouter(PersonalReportViewContainer)));
